import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ITableDescriptor } from '@shared/interfaces/table-descriptor.interface';
import { es } from 'date-fns/locale';
import { bookingsListMock } from 'src/mocks/bookings-fake.mock';
import { TableDescriptor } from './table-descriptor';
import { Subscription} from 'rxjs';
import { BookingService } from '@shared/services/booking.service';
import { format, parse } from 'date-fns';
import { ApiService } from '../../shared/services/api.service';
import { PlanningService } from './services/planning.service';


@Component({
  selector: 'app-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss']
})
export class PlanningComponent implements OnInit {

  public loading = true;
  public bookingsData!: any[];
  public locale: Locale = es;
  public filteredPlanningData: any[] = [];
  private planningDataSubscription!: Subscription;
  public searcherCriteria: string = '';
  public toolbarFiltersTable!: ITableDescriptor;
  private selectedFiltersSubscription!: Subscription;
  private selectedActivitySubscription!: Subscription;

  constructor(
    private bookingService: BookingService,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    public planningService: PlanningService
  ) {}

  ngOnInit() {
    this.apiService.getBookingServicesPlanning().subscribe(
      (response: any) => {
        this.bookingsData = response;
        this.planningService.bookingsDataAll = [...this.bookingsData];

        this.planningService.filteredPlanningDataSet = [...this.bookingsData];
        this.planningService.bookingsData = response;
        
        this.planningDataSubscription = this.planningService.filteredPlanningDataGet.subscribe((data:any[]) => {
          this.filteredPlanningData = data;
        });
      }
    )

    this.loading = false;
    this.toolbarFiltersTable = new TableDescriptor();

    this.selectedFiltersSubscription = this.bookingService.combinedSelection$.subscribe((combinedSelection: { offices: string[], services: string[], seats: number[], date: Date[]}) => {
      this.applyFilters(combinedSelection);
    });
  }

  ngOnDestroy() {
    if (this.selectedActivitySubscription) {
      this.selectedActivitySubscription.unsubscribe();
    }
    if (this.planningDataSubscription) {
      this.planningDataSubscription.unsubscribe();
    }
  }

  applyFilters(selectedFilters: { offices: string[], services: string[], seats: number[], date: Date[] }) {
    if(this.bookingsData){
      const { offices, services, seats, date } = selectedFilters;
      this.filteredPlanningData = this.bookingsData.filter((booking) =>
      (offices.length === 0 || offices.includes(booking.office)) &&
      (services.length === 0 || services.includes(booking.service)) &&
      (seats.length === 0 || seats.includes(booking.seats)) &&
      (date?.length === 0 || date && this.isBookingOnSelectedDateRange(booking.date, date))
      );
    }
  }

  isBookingOnSelectedDateRange(bookingDate: Date, selectedDateRange: Date[]): boolean {
    return selectedDateRange.some(selectedDate => {
      const startDate = new Date(selectedDate);
      const endDate = new Date(selectedDate.getTime() + 24 * 60 * 60 * 1000);

      const bookingDatePart = new Date(bookingDate.getFullYear(), bookingDate.getMonth(), bookingDate.getDate());
      const startDatePart = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      const endDatePart = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

      return (
        bookingDatePart >= startDatePart &&
        bookingDatePart < endDatePart
      );
    });
  }

  setPlanningData(data: any) {
    this.filteredPlanningData = data;
  }



  formatFullDate(isoDataString: string) {
    if(!isoDataString) {
      return 'Fecha y hora no disponiles'
    }
    const date = new Date(isoDataString);
    return format(date, 'dd-MM-yyyy');
  }

  public formatDate(date: Date): string {
    if (date instanceof Date && !isNaN(date.getTime())) {
      return format(date, 'EEEE dd/MM/yyyy', { locale: this.locale });
    } else {
      return 'Fecha no válida';
    }
    // return format(date, 'EEEE dd/MM/yyyy', { locale: this.locale });
  }
}
